import { ZfBanner, ZfDialog, ZfDialogContent, ZfDialogFooter, ZfDialogHeader, ZfStack, ZfTextButton, ZfTypography } from '@zafire/react';
import { type FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePrevious } from '../hooks';

interface IProps {
    isPresentationMode: boolean;
    setPresentationMode: (isPresentationModeOn: boolean) => void;
}

export const FamilyTreeWarningDialog: FunctionComponent<IProps> = ({ isPresentationMode, setPresentationMode }) => {
    const { t } = useTranslation();
    const [showDialog, setShowDialog] = useState(false);
    const prevIsPresentationMode = usePrevious(isPresentationMode);

    useEffect(() => {
        if (prevIsPresentationMode != null && !prevIsPresentationMode && isPresentationMode) {
            setShowDialog(true);
        }
    }, [isPresentationMode, prevIsPresentationMode]);

    const onCancel = () => {
        setPresentationMode(false);
        setShowDialog(false);
    };

    const onProceed = () => setShowDialog(false);

    return (
        <ZfDialog show={showDialog} onDialogClose={onCancel} size="medium" position="center">
            <ZfTypography>
                <ZfDialogHeader>{t('familyTreePresentationDialogTitle')}</ZfDialogHeader>
                <ZfDialogContent>
                    <ZfStack spacing="medium">
                        <ZfTypography variant="body-medium">{t('familyTreePresentationDialogText')}</ZfTypography>
                        <ZfBanner type="warning" dismissible={false}>
                            {t('familyTreePresentationDialogWarning')}
                        </ZfBanner>
                    </ZfStack>
                </ZfDialogContent>
                <ZfDialogFooter>
                    <ZfStack slot="primary" direction="row" spacing="extra-small">
                        <ZfTextButton size="medium" hierarchy="tertiary" onClick={onCancel}>
                            {t('familyTreePresentationDialogCancel')}
                        </ZfTextButton>
                        <ZfTextButton size="medium" hierarchy="primary" onClick={onProceed}>
                            {t('familyTreePresentationDialogProceed')}
                        </ZfTextButton>
                    </ZfStack>
                </ZfDialogFooter>
            </ZfTypography>
        </ZfDialog>
    );
};
